import { Storage } from '../core/storage.js';

/**
 * Front-my-End — Scratch Pad Component
 *
 * Persists persistent scratchpad notes to localStorage.
 */
export class ScratchPad {
  constructor(panelEl, textareaEl, { onConsole, panelSystem } = {}) {
    this.panel = panelEl;
    this.textarea = textareaEl;
    this.onConsole = onConsole || (() => {});
    this.panelSystem = panelSystem || null;
  }

  init() {
    if (this.textarea) {
      this.textarea.value = Storage.getNotes();
      this.textarea.addEventListener('input', () => {
        Storage.setNotes(this.textarea.value);
      });
    }
    const closeBtn = this.panel ? this.panel.querySelector('.scratch-close-btn') : null;
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.close();
      });
    }
  }

  isOpen() {
    return this.panel && !this.panel.classList.contains('hidden-panel');
  }

  open() {
    if (!this.panel) return;
    this.panel.classList.remove('hidden-panel');
    this.panel.classList.remove('minimized');
    const ps = this.panelSystem;
    if (ps && typeof ps.bringToFront === 'function') ps.bringToFront(this.panel);
    if (this.textarea) this.textarea.focus();
    this.onConsole('Scratch pad opened.');
  }

  close() {
    if (!this.panel) return;
    const ps = this.panelSystem;
    if (ps && this.panel.classList.contains('focused') && typeof ps.exitFocus === 'function') {
      ps.exitFocus();
    }
    this.panel.classList.add('hidden-panel');
    this.onConsole('Scratch pad closed.');
  }

  toggle() {
    if (this.isOpen()) this.close();
    else this.open();
  }
}
